export const MIN_PASSWORD_LENGTH_LEGACY = 6;
export const MIN_PASSWORD_LENGTH = 8;
export const MAX_PASSWORD_LENGTH = 64;
export const MIN_NAME_LENGTH = 3;
export const CURRENT_DATE = new Date();
export const DEFAULT_SEARCH_ITEMS_LIMIT = 10;
